import { render, staticRenderFns } from "./perfectInformation-detail.vue?vue&type=template&id=a249ec64&scoped=true"
import script from "./perfectInformation-detail.vue?vue&type=script&lang=js"
export * from "./perfectInformation-detail.vue?vue&type=script&lang=js"
import style0 from "./perfectInformation-detail.vue?vue&type=style&index=0&id=a249ec64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a249ec64",
  null
  
)

export default component.exports